import { render, staticRenderFns } from "./dropdown-wrapper.vue?vue&type=template&id=36eea9be&scoped=true"
import script from "./dropdown-wrapper.vue?vue&type=script&lang=ts"
export * from "./dropdown-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./dropdown-wrapper.vue?vue&type=style&index=0&id=36eea9be&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eea9be",
  null
  
)

export default component.exports